import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs2/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs2/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs2/core-js/object/define-property";
import React from "react";
export default function extractChildren(children, types) {
  var _children = [];
  var components = {};
  var result;

  if (_Array$isArray(types)) {
    React.Children.toArray(children).some(function (child) {
      if (child.type && child.type === React.Fragment) {
        result = extractChildren(child.props.children, types);
        return true;
      }

      if (child.type && types.includes(child.type.displayName)) {
        if (Object.prototype.hasOwnProperty.call(components, child.type.displayName)) {
          var childs = _Array$isArray(components[child.type.displayName]) ? [].concat(_toConsumableArray(components[child.type.displayName]), [child]) : [components[child.type.displayName], child];
          components[child.type.displayName] = childs;
        } else {
          components[child.type.displayName] = child;
        }
      } else {
        _children.push(child);
      }

      return false;
    });
    return result || _objectSpread(_objectSpread({}, components), {}, {
      children: _children
    });
  }

  throw new Error("extractChildren types parameter must be an Array");
}
//# sourceMappingURL=extractChildren.js.map